export const generateThreadItemId = ({
  orgId,
  streamId,
  channelId,
  anchorItemId,
  streamItemId,
}) =>
  [orgId, streamId, channelId, anchorItemId, streamItemId]
    .filter(Boolean)
    .join('/');
